module.exports = __webpack_public_path__ + "img/lookbook_1_right.7f3ad9e2.png";